import React, {
  Children,
  cloneElement,
  isValidElement,
  useCallback,
  useState,
} from 'react'
import { Popup } from '../popup'
import { IframeContainer } from '../iframe'
import { useSnippets } from '../snippet'

import * as styles from './instructions-video.module.scss'

type Props = {
  children: React.ReactNode
  src: string
}

export const InstructionsVideo = ({ children, src }: Props) => {
  const s = useSnippets()

  const [isVideoOpen, setIsVideoOpen] = useState(false)

  const openVideo = useCallback(() => setIsVideoOpen(true), [])
  const closeVideo = useCallback(() => setIsVideoOpen(false), [])

  const child = Children.only(children) as React.ReactElement<any, 'button'>
  const props = { onClick: openVideo }

  return (
    <>
      {isValidElement(child) ? cloneElement(child, props) : null}
      <Popup className={styles.popup} isOpen={isVideoOpen} onClose={closeVideo}>
        <IframeContainer className={styles.iframe} transparent>
          <iframe
            title={s.see_how_it_works}
            src={src}
            allowFullScreen
            loading="lazy"
          />
        </IframeContainer>
      </Popup>
    </>
  )
}
